export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
      <a
        href="https://kaspreadsheet.com/category-911-Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20turquoise%20running%20sneakers%20suspended%20in%20mid-air%20with%20splashing%20water%20droplets%20frozen%20in%20motion%2C%20dynamic%20sports%20action%20photography%2C%20bright%20white%20studio%20background%20with%20cyan%20gel%20lighting%2C%20high%20speed%20capture%20with%20crisp%20textile%20and%20rubber%20details%2C%20energetic%20athletic%20product%20showcase&width=600&height=440&seq=cat-v2-x1k3m&orientation=landscape"
          alt="Shoes"
          title="Shoes - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Shoes</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-912/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Plush%20lavender%20cashmere%20hoodie%20draped%20over%20a%20mid-century%20modern%20armchair%20with%20walnut%20wood%20legs%2C%20soft%20afternoon%20sunlight%20through%20venetian%20blinds%20creating%20striped%20shadow%20patterns%2C%20cozy%20contemporary%20interior%20photography%2C%20dusty%20rose%20and%20warm%20gray%20tones%2C%20sophisticated%20lifestyle%20composition&width=600&height=440&seq=cat-v2-r7n2p&orientation=landscape"
          alt="Hoodies / Sweaters"
          title="Hoodies Sweaters - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Hoodies / Sweaters</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-913/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-2 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Geometric%20color-blocked%20t-shirts%20arranged%20in%20a%20perfect%20gradient%20rainbow%20fan%20pattern%20on%20polished%20concrete%20floor%2C%20bold%20graphic%20product%20photography%2C%20overhead%20flat%20lay%20with%20sharp%20overhead%20studio%20lighting%2C%20vivid%20coral%20yellow%20and%20emerald%20tones%2C%20striking%20minimalist%20fashion%20editorial&width=600&height=440&seq=cat-v2-t4j8q&orientation=landscape"
          alt="T-Shirts"
          title="T-Shirts - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">T-Shirts</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-914/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Distressed%20leather%20biker%20jacket%20with%20silver%20zipper%20details%20propped%20against%20a%20exposed%20brick%20wall%20with%20neon%20pink%20sign%20reflection%2C%20urban%20street%20style%20photography%2C%20moody%20ambient%20lighting%20from%20street%20lamps%2C%20midnight%20navy%20tones%20with%20warm%20neon%20glow%2C%20edgy%20editorial%20fashion%20shot&width=600&height=440&seq=cat-v2-w9f5s&orientation=landscape"
          alt="Jackets"
          title="Jackets - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Jackets</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-915/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Crisp%20white%20linen%20trousers%20and%20tailored%20shorts%20floating%20weightlessly%20against%20a%20terracotta%20colored%20abstract%20painted%20backdrop%2C%20high%20fashion%20editorial%20photography%2C%20soft%20diffused%20studio%20lighting%20with%20gentle%20gradient%20shadows%2C%20Mediterranean%20warm%20earth%20tones%2C%20art%20gallery%20inspired%20composition&width=600&height=440&seq=cat-v2-b2m6t&orientation=landscape"
          alt="Pants / Shorts"
          title="Pants Shorts - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Pants / Shorts</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-916/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Retro%20trucker%20cap%20with%20embroidered%20palm%20tree%20patch%20and%20woven%20straw%20sunhat%20displayed%20on%20a%20sandy%20beach%20with%20gentle%20ocean%20waves%20in%20background%2C%20golden%20hour%20sunset%20lighting%2C%20tropical%20lifestyle%20photography%2C%20warm%20amber%20and%20oceanic%20blue%20tones%2C%20vacation%20inspired%20editorial&width=600&height=440&seq=cat-v2-h5k9u&orientation=landscape"
          alt="Headwear"
          title="Headwear - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Headwear</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-917/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Perfectly%20coordinated%20athleisure%20set%20in%20sage%20green%20and%20ivory%20white%20laid%20out%20geometrically%20on%20a%20speckled%20terrazzo%20surface%2C%20modern%20fitness%20lifestyle%20photography%2C%20bright%20overhead%20ring%20light%20creating%20crisp%20defined%20shadows%2C%20fresh%20botanical%20aesthetic%20with%20eucalyptus%20sprigs%2C%20contemporary%20clean%20composition&width=600&height=440&seq=cat-v2-z8n1v&orientation=landscape"
          alt="Sets"
          title="Sets - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Sets</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-918/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-2 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Organic%20bamboo%20fiber%20underwear%20folded%20into%20origami%20crane%20shapes%20on%20a%20smooth%20river%20stone%20surface%2C%20zen%20garden%20aesthetic%20with%20raked%20sand%20patterns%2C%20soft%20diffused%20daylight%2C%20minimalist%20Japanese%20inspired%20product%20photography%2C%20tranquil%20sage%20and%20stone%20gray%20palette%20with%20meditative%20composition&width=600&height=440&seq=cat-v2-l3q4w&orientation=landscape"
          alt="Underwear / Underpants"
          title="Underwear Underpants - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Underwear / Underpants</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-919/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Vintage%20inspired%20baseball%20jersey%20with%20bold%20red%20pinstripes%20hanging%20in%20an%20empty%20stadium%20locker%20room%2C%20dramatic%20spotlight%20illumination%2C%20nostalgic%20sports%20documentary%20photography%2C%20deep%20navy%20and%20crimson%20tones%20with%20metallic%20locker%20reflections%2C%20cinematic%20athletic%20atmosphere&width=600&height=440&seq=cat-v2-y6p7x&orientation=landscape"
          alt="Jersey"
          title="Jersey - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Jersey</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-920/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Eclectic%20mix%20of%20tortoiseshell%20sunglasses%20silver%20cuff%20bracelet%20and%20silk%20pocket%20square%20arranged%20on%20a%20glossy%20black%20piano%20surface%2C%20luxury%20accessories%20editorial%20photography%2C%20dramatic%20spotlight%20creating%20sharp%20reflections%20and%20deep%20shadows%2C%20jet%20black%20with%20warm%20tortoiseshell%20amber%20accents%2C%20high%20contrast%20sophisticated%20composition&width=600&height=440&seq=cat-v2-d9r5y&orientation=landscape"
          alt="Accessories"
          title="Accessories - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Accessories</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-921/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Sculptural%20architectural%20leather%20handbag%20with%20geometric%20brass%20hardware%20displayed%20on%20a%20pristine%20white%20pedestal%20in%20an%20art%20gallery%20setting%2C%20museum%20quality%20product%20photography%2C%20diffused%20gallery%20track%20lighting%2C%20rich%20cognac%20brown%20against%20stark%20white%2C%20high%20art%20minimalist%20fashion%20presentation&width=600&height=440&seq=cat-v2-g2s8z&orientation=landscape"
          alt="Bags"
          title="Bags - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Bags</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-922/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Handwoven%20artisan%20leather%20belt%20with%20intricate%20braided%20detailing%20coiled%20into%20an%20infinity%20symbol%20on%20raw%20unpolished%20marble%20slab%2C%20craft%20focused%20product%20photography%2C%20warm%20directional%20side%20light%20accentuating%20texture%20and%20grain%2C%20rustic%20cognac%20and%20charcoal%20tones%2C%20tactile%20heritage%20craftsmanship%20aesthetic&width=600&height=440&seq=cat-v2-u7t3a&orientation=landscape"
          alt="Belts"
          title="Belts - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Belts</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-923/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-1 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Art%20deco%20crystal%20perfume%20bottle%20with%20gold%20atomizer%20reflecting%20prismatic%20rainbow%20light%20against%20a%20midnight%20blue%20velvet%20backdrop%2C%20luxury%20fragrance%20photography%2C%20single%20dramatic%20spotlight%20creating%20crystal%20light%20refractions%2C%20deep%20sapphire%20with%20iridescent%20rainbow%20highlights%2C%20glamorous%20vintage%20Hollywood%20aesthetic&width=600&height=440&seq=cat-v2-v1m9b&orientation=landscape"
          alt="Perfumes"
          title="Perfumes - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Perfumes</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>

      <a
        href="https://kaspreadsheet.com/search-924/name/Shoes.html"
        target="_blank"
        rel="noopener nofollow"
        className="col-span-2 group relative h-[220px] rounded-2xl overflow-hidden cursor-pointer"
      >
        <img
          src="https://readdy.ai/api/search-image?query=Whimsical%20kaleidoscopic%20arrangement%20of%20vintage%20buttons%20enamel%20pins%20fabric%20swatches%20and%20sewing%20notions%20scattered%20on%20a%20rustic%20reclaimed%20wood%20table%2C%20craft%20room%20creative%20chaos%20photography%2C%20warm%20incandescent%20lighting%20with%20cozy%20workshop%20atmosphere%2C%20eclectic%20mix%20of%20jewel%20tones%20and%20metallic%20accents%2C%20artisanal%20handmade%20aesthetic&width=600&height=440&seq=cat-v2-c8w4d&orientation=landscape"
          alt="Other Stuff"
          title="Other Stuff - Browse on kaspreadsheet.com"
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <p className="text-background-50 text-lg font-semibold leading-tight">Other Stuff</p>
          <p className="text-background-50/70 text-xs mt-1 font-light">Explore &rarr;</p>
        </div>
      </a>
    </div>
  );
}